import {API_BASE_URL} from '../../constants';
import {get} from '../api';

export function getEnum(token, enqueueSnackbar, enumName, setValue) {
  get(`${API_BASE_URL}/enums/${enumName}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    responseType: 'json',
  })
    .then(res => {
      const list = res.data;
      setValue(list);
    })
    .catch(error => {
      console.error(`Failed to load enum ${enumName}:`, error);
      if (enqueueSnackbar) {
        enqueueSnackbar(`Fehler beim Laden von ${enumName}`, {
          variant: 'error',
        });
      }
    });
}
